/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=2b30eade"
import script from "./NotificationsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=2b30eade&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports